import { render, staticRenderFns } from "./SucursalRespuesta.vue?vue&type=template&id=cfdf753e"
import script from "./SucursalRespuesta.vue?vue&type=script&lang=js"
export * from "./SucursalRespuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports